import {RouteRecordRaw} from "vue-router";
import ContestsScreen from "@/contest/views/ContestsScreen.vue";

const routes: RouteRecordRaw[] = [
    {
        path: '/contests',
        name: 'contests',
        meta: {
            title: "Challenges"
        },
        component: ContestsScreen
    }
];

export default routes;
